export namespace PaymentStatusConstants {
  export const AWAITING_PREAUTH = 'Awaiting preauth';
  export const PREAUTHORIZED = 'Preauthorized';
  export const PREAUTH_FAILED = 'Preauth failed';
  export const PREAUTH_CANCELLED = 'Preauth cancelled';
  export const AWAITING_PROCESSING = 'Awaiting processing';
  export const PROCESSED = 'Processed';
  export const PROCESSING_FAILED = 'Processing failed';
  export const VOID_REQUESTED = 'Void requested';
  export const VOIDED = 'Voided';
  export const VOID_FAILED = 'Void failed';
  export const MANUAL_REVIEW = 'Manual review';
  export const ACH_NEW = 'Ach new';
  export const ACH_DECLINED = 'Ach declined';
  export const ACH_IN_PROGRESS = 'Ach in progress';
  export const ACH_CANCELLED = 'Ach cancelled';
  export const ACH_CANCELLED_INSUFFICIENT_FUNDS = 'Ach cancelled insufficient funds';
  export const ACH_COMPLETED = 'Ach completed';
  export const ACH_RETURNED_INSUFFICIENT_FUNDS = 'Ach returned insufficient funds';
  export const REFUND_REQUESTED = 'Refund requested';
  export const REFUNDED = 'Refunded';
}

export enum PaymentStatusGroup {
  Completed,
  Processing,
  Error
}
